import { useState, useContext, useMemo } from 'react'
import { Typography, TextField, Button, Stack, Switch } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import moment from 'moment-timezone'

import { AppContext } from '/providers/app-context'
import { toggleScannerPassEnabled } from '/providers/studio-api'
import StyledPaper from '/components/paper'
import ActionErrorDialog from '/components/action-error-dialog'
import useActionErrorDialog from '/components/use-action-error-dialog'


const PassEditorEvent = ({ pass, template, setPass }) => {

  return (
    <div className='h-full'>
      <StyledPaper>
        <Typography variant="h6" sx={{ p: 2 }}>Event Ticket Editor</Typography>
      </StyledPaper>
      <div className='overflow-y-scroll h-full pb-32'>
        <ManageTab pass={pass} templateId={template.template_id} setPass={setPass} />
      </div>
    </div>
  )
}

export default PassEditorEvent



const ManageTab = ({ pass, templateId, setPass }) => {

  const { apiSource, apiKey, setProcessing } = useContext(AppContext)

  const [enabled, setEnabled] = useState(!pass.variables.scan.disabled)
  const [note, setNote] = useState("")
  const { actionError, errorDialogOpen, setErrorDialogOpen, showActionError } = useActionErrorDialog()

  const passCurrentlyEnabled = useMemo(() => !pass.variables.scan.disabled, [pass.variables.scan.disabled])

  const saveEnabledDisabled = async () => {
    setProcessing(true)
    const result = await toggleScannerPassEnabled({ apiSource, apiKey, templateId, passId: pass.pass_id, enabled, note })
    setProcessing(false)

    if (result.error) {
      showActionError(result.error, "Error updating ticket status")
    } else {
      setPass(result)
      setNote("")
      enqueueSnackbar({ message: 'Ticket ' + (enabled ? "enabled" : "disabled"), variant: 'success' })
    }
  }

  return (
    <>
      <div className='flex flex-1 flex-col justify-around items-center'>
        <div>
          <div className='flex flex-col justify-around items-center gap-10'>
            <div style={{ width: 400 }} className='flex flex-col gap-5'>

              <StyledPaper>
                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                  <Typography>Event Ticket status: Disabled</Typography>
                  <Switch checked={enabled} onChange={e => setEnabled(e.target.checked)} />
                  <Typography>Enabled</Typography>
                </Stack>

                {!enabled && <div className='mt-5 mb-5 '>Disabled: {formatDate(pass.variables.scan.disabled_date)}</div>}

                <TextField multiline fullWidth rows={4} label="Note" onChange={e => setNote(e.target.value)} helperText={`Add a note to explain why you are ${passCurrentlyEnabled ? "disabling" : "enabling"} this ticket `} slotProps={{
                  inputLabel: {
                    shrink: true,
                  }
                }}>{note}</TextField>
                <div className='self-end'>
                  <Button variant='contained' onClick={saveEnabledDisabled}>Save</Button>
                </div>
              </StyledPaper>
            </div>
          </div>
        </div>
      </div>
      <ActionErrorDialog title="Ticket update failed" open={enabled !== passCurrentlyEnabled} setOpen={setErrorDialogOpen} error={actionError} />
    </>
  )
}

const formatDate = ymd => moment(ymd, "YYYYMMDDHHmmSS").format("DD MMM YYYY HH:mm") 
